<template>
  <div>
    <div class="md:hidden">
      <div v-for="category in displayedCategories" :key="category.key">
        <div class="relative mt-12 mb-6">
          <div class="absolute inset-0 flex items-center" aria-hidden="true">
            <div class="w-full border-t border-yellow-700"></div>
          </div>
          <div class="relative flex justify-center">
            <span class="px-4 bg-gray-200 uppercase text-xl text-gray-800">
              {{ category.title }}
            </span>
          </div>
        </div>
        <div class="grid gap-6">
          <div
            v-for="product in filteredProducts(category.key)"
            :key="product.id"
            class="border rounded overflow-hidden shadow-sm hover:shadow-lg bg-gray-100 relative pb-12"
            >
            <img :src="product.picture_url" :alt="product.title" v-if="product.picture_url" class="w-full">
            <div class="px-6 py-4">
              <div class="flex justify-between items-start text-xl mb-2 font-ramenya">
                <div class="font-bold text-gray-800 leading-tight uppercase">
                  {{ product.title }}
                </div>
                <div class="font-bold text-gray-700 leading-tight">
                  {{ product.price | amount }}
                </div>
              </div>
              <div class="text-sm text-yellow-700 -mt-2 mb-2" v-if="product.description">
                {{ product.description }}
              </div>
              <p class="text-gray-600 text-sm uppercase mb-3">
                {{ product.ingredients.join(" • ") }}
              </p>
              <div class="absolute bottom-0 right-0 pb-6 pr-6 w-full text-right">
                <button
                  class="bg-yellow-600 hover:bg-yellow-500 text-white font-bold py-2 px-4 rounded outline-none focus:outline-none"
                  @click="orderProduct(product)">
                  Commander
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden md:block">
      <div class="flex flex-row justify-center mb-12 text-lg font-thin text-gray-800 text-center uppercase">
        <a
          v-for="category in displayedCategories"
          class="cursor-pointer py-2 mx-6"
          :class="{'font-bold border-b-2 border-yellow-700': (currentCategory == category.key)}"
          @click="currentCategory = category.key"
          :key="category.key">
          {{ category.title }}
        </a>
      </div>
      <div class="grid md:grid-cols-2 xl:grid-cols-4 gap-6">
        <div
          v-for="product in filteredProducts(currentCategory)"
          :key="product.id"
          class="border rounded overflow-hidden shadow-sm hover:shadow-lg bg-gray-100 relative pb-12"
          >
          <img :src="product.picture_url" :alt="product.title" v-if="product.picture_url">
          <div class="px-6 py-4">
            <div class="flex justify-between items-start text-xl mb-2 font-ramenya">
              <div class="font-bold text-gray-800 leading-tight uppercase mr-1">
                {{ product.title }}
              </div>
              <div class="font-bold text-gray-700 leading-tight">
                {{ product.price | amount }}
              </div>
            </div>
            <div class="text-sm text-yellow-700 -mt-2 mb-2" v-if="product.description">
              {{ product.description }}
            </div>
            <p class="text-gray-600 text-sm uppercase mb-3">
              {{ product.ingredients.join(" • ") }}
            </p>
            <div class="absolute bottom-0 right-0 pb-6 pr-6 w-full text-right">
              <button
                class="bg-yellow-600 hover:bg-yellow-500 text-white font-bold py-2 px-4 rounded outline-none focus:outline-none"
                @click="orderProduct(product)">
                Commander
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal ref="siteModal">
      <div slot="title">
        <div class="font-bold text-gray-800 uppercase">
          Choisissez votre restaurant
        </div>
      </div>
      <div
        v-for="site in sites"
        :key="site.id"
        class="relative rounded-lg border-2 p-6 my-3 cursor-pointer"
        :class="{'bg-yellow-100 border-yellow-500 shadow-md': isCurrentSite(site)}"
        @click="selectSite(site)"
        >
        <div class="flex items-center">
          <div class="w-6 flex justify-between items-center mr-6">
            <svg class="w-6 h-6" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g :stroke="isCurrentSite(site) ? 'none' : '#111111'" stroke-width="1" fill="none" fill-rule="evenodd">
                <g fill-rule="nonzero">
                  <path d="M31.1442786,171.840796 C5.2779518,146.858262 -5.09578082,109.862896 4.01023318,75.0738981 C13.1162472,40.2848999 40.2848999,13.1162472 75.0738981,4.01023318 C109.862896,-5.09578082 146.858262,5.2779518 171.840796,31.1442786 C209.549474,70.1869539 209.010186,132.247241 170.628714,170.628714 C132.247241,209.010186 70.1869539,209.549474 31.1442786,171.840796 Z" :fill="isCurrentSite(site) ? '#ECC94B' : '#F7FAFC'"></path>
                  <polygon v-if="isCurrentSite(site)" fill="#FFFFF0" points="66.6666667 89.4527363 89.5522388 112.437811 132.338308 69.6517413 146.268657 83.7810945 89.5522388 140.298507 52.7363184 103.482587 66.6666667 89.3532338"></polygon>
                </g>
              </g>
            </svg>
          </div>
          <div class="uppercase leading-none">
            <p class="text-2xl text-gray-800 mb-2">
              Ramen Ya
              <span class="font-bold">{{ site.title }}</span>
            </p>
            <p class="text-sm text-gray-700">
              <i class="fas fa-map-marker-alt mr-1 text-yellow-800 text-opacity-50"></i>
              {{ site.street }}
            </p>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="flex justify-between items-center">
          <a class="cursor-pointer text-gray-600" @click="$refs.siteModal.close()">
            Annuler
          </a>
          <button class="flex items-center gap-2 bg-gray-400 text-white font-bold py-2 px-4 rounded outline-none focus:outline-none cursor-not-allowed" disabled v-if="!currentSite">
            Suivant
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
            </svg>
          </button>
          <button class="flex items-center gap-2 bg-yellow-600 hover:bg-yellow-500 text-white font-bold py-2 px-4 rounded outline-none focus:outline-none" @click="submitSite()" v-else>
            Suivant
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
            </svg>
          </button>
        </div>
      </div>
    </modal>
    <modal ref="deliveryModal" v-if="currentSite">
      <div slot="title">
        <div class="font-bold text-gray-800 uppercase">
          Mode de livraison
        </div>
      </div>
      <button
        class="w-full rounded-lg border-2 p-6 my-3 text-center bg-gray-200 hover:bg-gray-300 hover:shadow-md cursor-pointer"
        @click="orderProduct(currentProduct, true)">
        <div class="text-2xl font-bold mb-2">
          Click and collect
        </div>
        <div class="text-gray-700">
          Recevez un SMS quand votre commande est
          <br>
          prête à être récupérée au restaurant
        </div>
      </button>
      <a class="block rounded-lg border-2 p-6 my-3 cursor-pointer text-center bg-gray-200 hover:bg-gray-300 hover:shadow-md" :href="currentSite.uber_eats_url" target="_blank">
        <div class="w-32 mx-auto mb-2">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="57 57 369 61" data-reactid="17"><g data-reactid="18"><path fill="#262626" d="M228.06,81.56c-5.47,0-9.35,4.28-9.35,10.85v24.1h-8.35V74.09h8.25v5.18a11.19,11.19,0,0,1,9.94-5.48h3v7.77ZM204.59,95.3c0-12.65-9-22.11-21.18-22.11A21.83,21.83,0,0,0,161.73,95.3c0,12.64,9.75,22.2,22.47,22.2a22.17,22.17,0,0,0,18.3-9.06L196.44,104a14.78,14.78,0,0,1-12.24,6.17,14.22,14.22,0,0,1-14-12.14h34.41Zm-34.21-3.89c1.49-6.47,6.66-10.85,12.93-10.85s11.43,4.38,12.83,10.85Zm-35.1-18.22a21.12,21.12,0,0,0-15,6.27V58.25h-8.35v58.26h8.25v-5.38a21.45,21.45,0,0,0,15.12,6.37,22.16,22.16,0,1,0,0-44.31Zm-.6,36.85A14.69,14.69,0,1,1,149.3,95.4,14.58,14.58,0,0,1,134.68,110Zm-53.5-.4c8.06,0,14.32-6.18,14.32-15.44V58.25h8.65v58.26H95.6V111a21.24,21.24,0,0,1-15.41,6.47c-12.43,0-22-9.06-22-22.8V58.25H67v36C67,103.56,73,109.64,81.18,109.64Z" data-reactid="19"/><path fill="#5fb709" d="M252.32,58.25h40.87v10H263.36V82.45h29v9.66h-29v14.44h29.83v10H252.32ZM406.06,117.6c12.53,0,19.59-6,19.59-14.24,0-5.87-4.18-10.25-12.93-12.15l-9.25-1.89c-5.37-1-7.06-2-7.06-4,0-2.59,2.59-4.18,7.36-4.18,5.17,0,9,1.39,10,6.17h10.84c-.59-9-7.06-14.94-20.18-14.94-11.34,0-19.3,4.68-19.3,13.75,0,6.27,4.38,10.35,13.83,12.34l10.34,2.39c4.08.8,5.17,1.9,5.17,3.59,0,2.69-3.08,4.38-8.06,4.38-6.26,0-9.84-1.39-11.23-6.17H384.28C385.87,111.63,392.53,117.6,406.06,117.6Zm-24.93-1.09H369.4c-7.36,0-11.44-4.58-11.44-10.36V83.25h-8.25V73.49H358V61.24H368.9V73.49h12.23v9.76H368.9v20.11c0,2.29,1.59,3.39,4.08,3.39h8.15Zm-47-43v3.88a21.16,21.16,0,0,0-13.73-5,22.61,22.61,0,1,0,0,45.21,21.1,21.1,0,0,0,13.73-5v3.89H345v-43Zm-12.83,34.65a13.15,13.15,0,1,1,13-13.14A13,13,0,0,1,321.28,108.14Z" data-reactid="20"/></g></svg>
        </div>
        <div class="text-gray-700">
          Faites livrer vos ramens à domicile ou au bureau
        </div>
      </a>
      <div slot="footer">
        <div class="flex justify-between items-center">
          <a class="flex items-center gap-2 cursor-pointer text-gray-600" @click="$refs.deliveryModal.close(); $refs.siteModal.open()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
            </svg>
            Choix du restaurant
          </a>
        </div>
      </div>
    </modal>
    <modal ref="productModal">
      <div slot="title">
        <div class="flex items-baseline divide-x divide-gray-400 text-xl font-ramenya" v-show="currentStep == 0">
          <div class="font-bold text-gray-800 pr-3 uppercase">
            {{ currentProduct.title }}
          </div>
          <div class="text-gray-700 pl-3">
            {{ currentProduct.price | amount }}
          </div>
        </div>
        <div v-show="currentStep == 1">
          <div class="text-xl font-bold text-gray-800 pr-3">
            Ajouter des extras&nbsp;?
          </div>
          <div class="text-sm text-gray-700 md:mt-3">
            Si vous le souhaitez, vous pouvez ajouter jusqu'à 2 extras de chaque type. Prix indiqués par unité.
          </div>
        </div>
      </div>
      <div v-show="currentStep == 0">
        <div class="text-gray-600 text-sm uppercase" v-if="currentProduct.ingredients">
          {{ currentProduct.ingredients.join(" • ") }}
        </div>
        <div v-if="isAvailable(currentProduct)">
          <div class="md:flex md:justify-between items-center my-8">
            <div class="font-bold text-gray-800 leading-none mb-3 md:mb-0">
              Choix des nouilles&nbsp;:
            </div>
            <div class="bg-gray-200 text-sm text-gray-600 leading-none border-2 border-gray-200 rounded-full flex">
              <button
                class="flex-grow focus:outline-none rounded-r-full px-3 py-4"
                :class="{'bg-white rounded-full text-yellow-700 font-bold': (orderItem.variant == 'futsumen')}"
                @click="orderItem.variant = 'futsumen'"
                >
                <span>Futsumen (normales)</span>
              </button>
              <button
                class="flex-grow focus:outline-none rounded-l-full px-3 py-4"
                :class="{'bg-white rounded-full text-yellow-700 font-bold': (orderItem.variant == 'hosomen')}"
                @click="orderItem.variant = 'hosomen'">
                <span>Hosomen (fines)</span>
              </button>
            </div>
          </div>
          <div class="mb-8 md:mb-4" v-if="currentProduct.spicy">
            <div class="md:flex md:justify-between items-center">
              <div class="font-bold text-gray-800 leading-none mb-3 md:mb-0">
                Niveau de piment&nbsp;:
              </div>
              <div>
                <div class="bg-gray-200 text-sm text-gray-600 leading-none border-2 border-gray-200 rounded-full flex">
                  <button
                    class="flex-grow focus:outline-none rounded-r-full px-6 py-3"
                    :class="{'bg-white rounded-full text-yellow-700 font-bold': (orderItem.spiciness == 1)}"
                    @click="orderItem.spiciness = 1"
                    >
                    <div class="flex justify-around">
                      <img class="w-6 h-6" src="data:image/png;base64,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"/>
                    </div>
                  </button>
                  <button
                    class="flex-grow focus:outline-none rounded-r-full px-6 py-3"
                    :class="{'bg-white rounded-full text-yellow-700 font-bold': (orderItem.spiciness == 2)}"
                    @click="orderItem.spiciness = 2"
                    >
                    <div class="flex justify-around">
                      <img class="w-6 h-6 -mr-1" src="data:image/png;base64,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"/>
                      <img class="w-6 h-6" src="data:image/png;base64,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"/>
                    </div>
                  </button>
                  <button
                    class="flex-grow focus:outline-none rounded-r-full px-6 py-3"
                    :class="{'bg-white rounded-full text-yellow-700 font-bold': (orderItem.spiciness == 3)}"
                    @click="orderItem.spiciness = 3"
                    >
                    <div class="flex justify-around">
                      <img class="w-6 h-6" src="data:image/png;base64,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"/>
                      <img class="w-6 h-6 -mx-1" src="data:image/png;base64,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"/>
                      <img class="w-6 h-6" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAGbUlEQVRoge2YbWib1xXHf/d5kWzHbpzYRrKXLI6xExcvnWM3SSmrVw9CBukLhTawQbtmY182aFfYBqNQlq1lFLLtw76sLLSMfgjL9iGFwUiWbLQfWtalCXhxcONkkSPbsSK/SIltSc/LPfsgyZadSLEdW83Af7gIHp3nnv//nHPPvc+FdaxjHf/XML9oAsVw9CzbOnoqToXaNiQ+/yRzqZidUU5Sy4GTsl5Izxj7EFVVyu6BFZCaNZ6/nTTdgOi/lrJ7IAUcPWV335oy991Kmqf+/Ntbk6VsrXKRKsQ756gKJszn7KR60a/S7drGFJFh9yE5afj8ITqi3kyMm5iao/eaS5WDcB7HzvEd0byoNF8X6+7Bm7xpesNDAev6lcC/Pvh18rF7zVnWEup8e9PJ5hPVX94QtSylwZpRPNQXQOns/7MzBlMTlhUftVAiYywhwGXLgIB5vbHxbyKyXwMa0CJMdjr8560pnIwiPmYRvRpgPGblX/rJB79JliyjsmUg2tj4qhLZb+ScGmSj527UuK5iatwiNmLPkwcM4cgLP2ioLjVvWQSMNDVtNUR+mU+3yg+lsKYMpuImY8M2o0M2AHXJrKU2qHIrM0+XmrssApTWPwOqTNOkYscOKjs6sC0LBdRcsRkbChD9r03AhX0XTZ49M5+FYFo9VWruNW+j1+vrmwS+qwD70Uep6O1Fa41Op3GuXiU4q9h9opLHM4ptowZkhDRQM624XS1oxZ5S8695Bgzb/iEQNOrqCOzejREKYdXVYdj2XAd5/LLFV4ZMAs78e3s/M1CAZ9P89M+bih4n1lTAtebmCiXyfQCrrQ1z+3ZQCp1MIo5T9D0BWiIGvadNgmn61PT0M8Vs17SEAun0t4AGVV2N1dGBCgQA8MfH8cfGFhBeMETQQGhUceC4ev5wIhkp5mPNMiCgFLwG2ejb27Zln3ge/uAg7uzsHGFypIXc/pAbAlcOJxJFya+pgBtNTfsFdinLwmppQVVXgwheNIobieRFzv0WEvcBXwQPjt3Lz9plQOvXAaydO7Hb28EwsgL6+3GuXVtQMoU7s58XABmxrPe+EAGjjY0HgB5lmtiPPIKxeTMA7uXLuAMDWYHM1/qC6OdFiPzupVjsZtkFCFgi8isAq6sLe8cOMAwklcK7eBFnePiOResXRN4DPJEbs4bxi6X4W/UuNBIOv6pgt1FXR7C7G1VbCyK4/f04Fy7kRS6s95wINyfAF3nlexMTt5fib1UzMBYKbVdwRFkWgZ4ezJYWALzBQdxz5/BmZubJ58rHK4y+CK7I7w9NTv5lqT5XTUB0y5ZKT6k/ARuCTzxBsLMTZdvI9DTO+fNkcrWfr3NNLto54g7gwr+TNTWvLcfvqpWQ4fvHgD12VxdWdzeqpgbtujgffYTb13fXVullWyUu4IoMpZR65nAkkl6W39UgP9zY+Doi37Z37iS4dy9WKIT4Ps6ZM2Q+/RQvlZoT4BeUTm7B4oqMOnDgUDw+VtrTnbjvDIyEwz9F5E27tZVgby/G1q2I45D58EMy58/jJZPZTsN8t3FzI1c6w2mlvvFsPD64Ev/39Uk5Eg4fAd6w29oIPvkkatOmbOQ//hj30qWi5B0RHBEycHHGdZ86mEgMrZTDijLQ39ERqJ2YeAd42W5vx3r4YVAKLxLBGxzEGxiYK5tC8h7g5tqlC6ddzzt0MJFIrpQ8rCAD1+vrm0zLOg702Lt2YYbDUFmJJBL40ShOJLJgh11M3gGdgbfGbt48ciir776wLAHD4fBBgfcUNNitrRi1tSjTRCeTeLEY3tTUwk2qoF062UU7mlbqpZ5Y7Oz9El+WgMHW1mDFzMzbIvIKoOy6OoyNG0Fr/Olp/IkJ9KLjcCF5V0RckXdnXffHvYlEYrXIL0nAUCjUopU6oaBbAZZlYVRUZGt+eho/R3zxDquzxPGgz9X6R4+Nj/9zNYkvScCVhoZvimEcV0rVqrsY58/zd0Qf8ESGXZE39sTjf1TZx2uCogL6t2zZbLjukILquXucu5BffKb3YEDD0WB9/fsd/f3FP3xXCUXbqO+6X9JQnb9BK7yUWkzeh1kROemJvN8Vj59WoInF1pR4HiVL6EIo9K4SeVmBUkrNGQuIwOeI/MODsymt//618fElHX9XG/dcxJ+Ew8221p2I2MowUvj+Dcs0B74ai82Ug+A61rGOdTzY+B8V5DT7k/Rz+QAAAABJRU5ErkJggg=="/>
                    </div>
                  </button>
                </div>
              </div>
            </div>
            <div class="text-right text-sm text-red-700 mt-2">
              <span v-show="orderItem.spiciness == 1">Ça pique&nbsp;!</span>
              <span v-show="orderItem.spiciness == 2">Ça pique beaucoup&nbsp;!</span>
              <span v-show="orderItem.spiciness == 3">Ça pique ÉNORMÉMENT&nbsp;!</span>
            </div>
          </div>
        </div>
        <p v-else class="text-red-600 font-bold mt-6 text-center">
          Désolé, ce produit n'est plus disponible dans ce restaurant pour le moment.
        </p>
      </div>
      <div v-show="currentStep == 1">
        <div
          class="my-1 p-2 border rounded"
          v-for="extra in filteredProducts('extra')"
          :class="quantityExtra(extra) > 0 ? 'bg-yellow-100 border-yellow-500' : 'border-0'"
          v-show="orderItem.product_id != 36 || orderItem.product_id === 36 && (extra.id === 19 || extra.id === 16)"
          :key="extra.id">
          <div class="flex justify-between items-center">
            <div class="flex flex-grow flex-col">
              <div class="flex flex-grow items-baseline divide-x divide-gray-200">
                <div class="font-bold text-gray-800 pr-2 font-ramenya uppercase">
                  {{ extra.title }}
                </div>
                <div class="flex-grow text-gray-700 pl-2">
                  {{ extra.price | amount }}
                </div>
              </div>
              <div class="text-gray-600 text-xs md:text-sm" v-if="extra.ingredients">
                {{ extra.ingredients.join(' • ') }}
              </div>
            </div>
            <div class="w-32 ml-3" v-if="isAvailable(extra)">
              <div class="flex flex-row h-10 w-full rounded-lg bg-transparent">
                <button class="bg-gray-200 text-gray-600 hover:text-gray-700 hover:bg-gray-300 h-full w-20 rounded-l cursor-pointer outline-none focus:outline-none" @click="decrementExtra(extra)">
                  <span class="m-auto text-2xl">−</span>
                </button>
                <input
                  type="text"
                  disabled
                  :value="quantityExtra(extra)"
                  :class="quantityExtra(extra) > 0 ? 'text-gray-900' : 'text-gray-600'"
                  class="outline-none focus:outline-none text-center w-full bg-gray-100 font-semibold text-md hover:text-black focus:text-black md:text-basecursor-default flex items-center"
                />
                <button class="bg-gray-200 text-gray-600 hover:text-gray-700 hover:bg-gray-300 h-full w-20 rounded-r cursor-pointer outline-none focus:outline-none" @click="incrementExtra(extra)">
                  <span class="m-auto text-2xl">+</span>
                </button>
              </div>
            </div>
            <div class="w-32 ml-3 text-red-700 text-sm text-center uppercase opacity-75" v-else>
              Produit épuisé
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div v-show="currentStep == 0">
          <div v-if="isAvailable(currentProduct)" class="flex justify-between items-center">
            <a class="cursor-pointer text-gray-600" @click="cancelProduct(currentProduct)">
              Annuler
            </a>
            <button class="flex items-center gap-2 bg-yellow-600 hover:bg-yellow-500 text-white font-bold py-2 px-4 rounded outline-none focus:outline-none" @click="currentStep++">
              Suivant
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
              </svg>
            </button>
          </div>
          <div v-else class="flex justify-end items-center">
            <button class="text-gray-600 font-bold py-2 outline-none focus:outline-none" @click="cancelProduct(currentProduct)">
              Fermer
            </button>
          </div>
        </div>
        <div v-show="currentStep == 1">
          <div class="flex justify-between items-center">
            <a class="flex items-center gap-2 cursor-pointer text-gray-600" @click="currentStep--">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
              </svg>
              Précédent
            </a>
            <button
              class="text-white font-bold py-2 px-4 rounded outline-none focus:outline-none"
              :class="busy ? 'bg-yellow-500 bg-opacity-50 cursor-not-allowed' : 'bg-yellow-600 hover:bg-yellow-500'"
              :disabled="busy"
              @click="submitProduct()">
              <i class="fas mr-1" :class="busy ? 'fa-spinner fa-pulse' : 'fa-check'"></i>
              Valider
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import Modal from '../../../ui/Modal'
  import Amount from '../../../filters/Amount'
  import { OrderBus } from '../../../packs/ramenya/front'
  export default {
    components: {
      Modal
    },
    filters: {
      Amount
    },
    props: {
      products: Array,
      sites: Array
    },
    data() {
      return {
        order: {},
        busy: false,
        currentSite: null,
        currentCategory: 'ramen',
        currentProduct: {},
        currentStep: 0,
        orderItem: { extras: [] },
        displayedCategories: [{
          key: "ramen",
          title: "Les ramens"
        }, {
          key: "side",
          title: "Les gyozas & chashu don"
        }, {
          key: "drink",
          title: "Les boissons"
        }]
      }
    },
    mounted() {
      OrderBus.$on('order:updated', (order) => {
        this.order = order
        this.currentSite = this.sites.find((site) => site.id == this.order.site_id)
      })
    },
    methods: {
      isCurrentSite(site) {
        return this.currentSite && this.currentSite.id === site.id
      },
      isAvailable(product) {
        if (product && product.stocks && this.order.site_id) {
          return product.stocks.find((stock) => stock.site_id == this.order.site_id).available
        } else {
          return true
        }
      },
      submitProduct() {
        if (this.busy) return
        this.busy = true
        axios.post(
          this.order.items_url, {
            order_item: this.orderItem
          }
        ).then((response) => {
          Turbolinks.visit(this.order.url)
        }).catch((error) => {
          console.error(error)
          this.busy = false
        })
      },
      selectSite(site) {
        this.currentSite = site
      },
      submitSite() {
        this.order.site_id = this.currentSite.id
        this.$refs.siteModal.close()
        this.$refs.deliveryModal.open()
        axios.patch(
          this.order.url, { order: { site_id: this.order.site_id }}
        )
      },
      filteredProducts(category) {
        return this.products.filter((product) => {
          return product.category == category
        })
      },
      orderProduct(product, force = false) {
        this.currentProduct = product
        if (!force && (this.order.site_id == null || this.order.items.length == 0)) {
          this.currentSite = null
          // this.selectSite(this.currentSite ? this.currentSite : this.sites[0])
          this.$refs.siteModal.open()
        } else {
          if (!force && this.order.items.length == 0) {
            this.$refs.deliveryModal.open()
          } else {
            this.currentStep = 0
            this.orderItem = {
              product_id: product.id,
              variant: (product.category == 'ramen' ? 'futsumen' : null),
              spiciness: (product.spicy ? 1 : null),
              extras: []
            }
            this.$refs.deliveryModal.close()
            if (product.category == 'ramen' || !this.isAvailable(product)) {
              this.$refs.productModal.open()
            } else {
              this.submitProduct()
            }
          }
        }
      },
      cancelProduct(product) {
        this.currentProduct = {}
        this.currentStep = 0
        this.orderItem = { extras: [] }
        this.$refs.productModal.close()
      },
      quantityExtra(extra) {
        const current = this.orderItem.extras.find((item) => item.product_id == extra.id)
        if (current) {
          return current.quantity
        } else {
          return 0
        }
      },
      decrementExtra(extra) {
        const index = this.orderItem.extras.findIndex((item) => item.product_id == extra.id)
        if (index >= 0) {
          const extra = this.orderItem.extras[index]
          if (extra.quantity == 1) {
            this.orderItem.extras.splice(index, 1)
          } else {
            extra.quantity -= 1
          }
        }
      },
      incrementExtra(extra) {
        let current = this.orderItem.extras.find((item) => item.product_id == extra.id)
        if (current) {
          if (current.quantity < 2) {
            current.quantity += 1
          }
        } else {
          current = {
            product_id: extra.id,
            quantity: 1
          }
          this.orderItem.extras.push(current)
        }
      }
    }
  }
</script>
